import { Autoplay, Keyboard, Mousewheel, Pagination } from 'swiper/modules'
import Swiper from 'swiper'

class SpotlightQuotesSlider extends HTMLElement {
  constructor() {
    super()

    const spotlightQuotesSliderElement = this
    const swiperHolder = spotlightQuotesSliderElement.querySelector('.swiper')
    const enableLoop = spotlightQuotesSliderElement.getAttribute('data-loop')
    const enableAutoplay = spotlightQuotesSliderElement.getAttribute('data-autoplay')
    const autoplaySpeed = spotlightQuotesSliderElement.getAttribute('data-autoplay-speed')
    const enableKeyboard = spotlightQuotesSliderElement.getAttribute('data-keyboard')
    const paginationElement = spotlightQuotesSliderElement.querySelector('.swiper-pagination')
    const mobileBreakpoint = 320
    const desktopBreakpoint = 640
    const swiperConfig = {
      modules: [Mousewheel, Pagination],
      mousewheel: {
        forceToAxis: true,
      },
      direction: 'horizontal',
      threshold: 10,
      edgeSwipeDetection: true,
      pagination: {
        clickable: true,
        el: paginationElement,
        renderBullet: (index) => `<button type="button" class="dot swiper-pagination-bullet" aria-label="Select slide ${index}" name="Select slide ${index}"></button>`,
      },
      breakpoints: {
        // when window width is >= 320px
        [mobileBreakpoint]: {
          slidesPerView: 1,
          spaceBetween: 12,
          centerSlides: true,
        },
        // when window width is >= 480px
        [desktopBreakpoint]: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
    }

    if (enableAutoplay && enableAutoplay === 'true') {
      swiperConfig.modules = swiperConfig.modules ? [...swiperConfig.modules, Autoplay] : [Autoplay]
    }

    if (enableLoop && enableLoop === 'true') {
      swiperConfig.loop = true
    }

    if (autoplaySpeed && autoplaySpeed > 0) {
      swiperConfig.autoplay = {
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        delay: autoplaySpeed,
      }
    }

    if (enableKeyboard && enableKeyboard === 'true') {
      swiperConfig.modules = swiperConfig.modules ? [...swiperConfig.modules, Keyboard] : [Keyboard]
      swiperConfig.keyboard = {
        enabled: true,
      }
    }

    new Swiper(swiperHolder, swiperConfig)

    window.addEventListener('shopify:section:load', () => new Swiper(swiperHolder, swiperConfig))
  }
}

// Check if element is defined, if not define it.
// eslint-disable-next-line no-undefined
if (customElements.get('spotlight-quotes-slider') === undefined) {
  customElements.define('spotlight-quotes-slider', SpotlightQuotesSlider)
}